import { gql } from "@apollo/client";

export const GET_REQ_CLIENTES_BY_DELEGACION = gql`
query allClientes($idDelegacion: Int!) {
    clientesByDelegacion(idDelegacion: $idDelegacion)
    {
        success,
        error,
        valorEsperado {
          codSap
          razonSocial
          cuit
          delegacion
          fA
          configurado
        }
    }
}`;